import $ from '@nodeModules/jquery';
import '@nodeModules/slick-carousel-latest';

export const initFeaturedBrands = () => {
	const $brandsPrevArrowEl = document.querySelector('.featured-brands__slider-nav-action--prev');
	const $brandsNextArrowEl = document.querySelector('.featured-brands__slider-nav-action--next');

	const $featuredBrandsSlider = document.querySelector('.featured-brands__slider');
	if ($featuredBrandsSlider) {
		$('.featured-brands__slider').on('init', function(event, slick) {
			$featuredBrandsSlider.classList.add('featured-brands__slider--is-initialized');
		}).slick({
	        dots: false,
	        autoplay: true,
	        centerMode: false,
	        speed: 1000,
	        rows: 0,
	        prevArrow: $brandsPrevArrowEl,
	        nextArrow: $brandsNextArrowEl,
	        responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1
				}
			},
		]
	    });
	}
};